import { PremierServiceProductDTO } from "../DTO/premierServiceProductDTO";
import { BasicRequest } from "./basicRequest";

export class CreatePremierServiceProductRequest extends BasicRequest{
    
    public premierServiceProduct!: PremierServiceProductDTO;

    constructor(){
        super();
    }
}